import type { SortInput } from '@zen/types';
import { usePagination } from '@zen/utils/hooks/pagination';

import { ProductAttributesDocument, type ProductAttributesQueryResult, type ProductAttributesQueryVariables } from '../graphql';
import { type CoreProductAttribute, CoreProductAttributeOrderInputField } from '../types';

const getSortBy = (order: SortInput | undefined) => {
  if (!order) return;

  const fieldConfig: { [key: string]: CoreProductAttributeOrderInputField } = {
    name: CoreProductAttributeOrderInputField.NAME,
    type: CoreProductAttributeOrderInputField.TYPE
  };

  return {
    field: fieldConfig[order.field],
    direction: order.direction
  };
};
const useProductAttributes = (accountId: string, order: SortInput | undefined) => {
  return usePagination<ProductAttributesQueryResult, ProductAttributesQueryVariables, CoreProductAttribute>(
    ProductAttributesDocument,
    'coreProductAttributes',
    { accountId, order: getSortBy(order) },
    20,
    {
      fetchPolicy: 'cache-and-network'
    }
  );
};

export default useProductAttributes;
